/*
 *  -----------------------------------------------------------------------
 *    <copyright file="login-step2.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';

import 'views/pages/uam/uam-styles.scss';

import { useTranslation } from 'hooks';

const InfoScreen = () => {
    const { t } = useTranslation();

    return (
        <div className="info-screen">
            <p>{t('uam:ifYouAreTryingToAccessOpraPleaseReferWelcomeEmail')}</p>
        </div>
    );
};

export default InfoScreen;
